<template>
  <b-modal
    id="modal-publier"
    title-class="modal__title"
    title="Publier les données du parc"
    @ok="activatePublishedStatus"
  >
    <p class="mt-3 mb-4">
      Avez-vous bien finalisée la saisie des informations ?
      Les données seront publiées instantanément sur GéoRisques.
    </p>
    <template #footer="{ ok, cancel }">
      <b-button
        variant="info"
        title="Rendre les données accessibles au grand public"
        @click="ok()"
      >
        Publier
      </b-button>
      <b-button
        variant="default"
        title="Annuler la publication des données du parc"
        @click="cancel()"
      >
        Annuler
      </b-button>
    </template>
  </b-modal>
</template>
<script setup>
import { BModal, BButton } from 'bootstrap-vue-next';
defineProps({
  activatePublishedStatus: {
    type: Function,
    required: true
  }
})
</script>
